import Modals from "components/Modal";
import TableTwo from "components/TableTwo";
import { DONATION__CATEGORY_ANALYTICS } from "navigation/routes";
import { Link } from "react-router-dom";
import { startCase } from 'lodash'
import useDonationReport from "hook/reports/useDonationReport";
import { formatMoney } from "utils/functions";
import zipcelx from "zipcelx";
import { format } from "date-fns";

const DonorClassificationReport = () => {
  const {
    currentData, setCurrentData, open, setOpen, updateMyData, skipPageReset,
    columns, data, setData, current, edit, setEdit,
    totalAmount, dataReport,
    setDateJoinedFrom, setDateJoinedTo, setDonationDateFrom, setDonationDateTo,
  } = useDonationReport()

  const rows = dataReport?.data?.data?.donation_report || data || [];

  function getExcel() {
    if (!rows.length) return;
    const headers = [
      { value: 'S/N', type: 'string' },
      { value: 'Date Joined', type: 'string' },
      { value: 'Name', type: 'string' },
      { value: 'Phone Number', type: 'string' },
      { value: 'Amount', type: 'number' },
      { value: 'Donation Date', type: 'string' },
      { value: 'City', type: 'string' },
      { value: 'Level', type: 'string' },
      { value: 'Fundraise', type: 'string' },
    ];
    const dataRows = rows.map((row, index) => [
      { value: index + 1, type: 'number' },
      { value: row?.user?.created_at ? format(new Date(row.user.created_at), 'MMM dd yyyy') : '-', type: 'string' },
      { value: row?.donor_name || '-', type: 'string' },
      { value: row?.donor_phone_number || '-', type: 'string' },
      { value: parseFloat(row?.transaction?.amount || 0), type: 'number' },
      { value: row?.created_at ? format(new Date(row.created_at), 'MMM dd yyyy') : '-', type: 'string' },
      { value: row?.user?.city?.name || '-', type: 'string' },
      { value: row?.user?.category?.name || '-', type: 'string' },
      { value: row?.donation_course?.tagline || '-', type: 'string' },
    ]);
    const summationRow = [
      { value: '', type: 'string' }, { value: '', type: 'string' }, { value: '', type: 'string' },
      { value: 'Total Amount', type: 'string' }, { value: totalAmount, type: 'number' },
      { value: '', type: 'string' }, { value: '', type: 'string' }, { value: '', type: 'string' }, { value: '', type: 'string' },
    ];
    zipcelx({ filename: 'Donor_Classification_Report', sheet: { data: [headers, ...dataRows, summationRow] } });
  }

  return (
    <>
      <div className="container-fluid px-4">
        <div className="d-sm-flex align-items-start justify-content-between mt-4">
          <div>
            <h1>Donor Classification Report</h1>
            <ol className="breadcrumb mb-2">
              <li className="breadcrumb-item"><Link to='#'>Donations</Link></li>
              <li className="breadcrumb-item active">All</li>
            </ol>
          </div>
          <Link className="btn btn-primary mb-2" to={`../${DONATION__CATEGORY_ANALYTICS}`} relative="path">View Analytics</Link>
        </div>
        <div className="card mb-4">
          <div className="card-header">
            <i className="fas fa-table me-1"></i>
            Donations
          </div>
          <div className="row px-3 pt-3 pb-2 g-2">
            <div className="col-12 col-md-4">
              <div className="d-flex align-items-end gap-2">
                <div className="form-inline flex-fill">
                  <label className="form-label mb-1 small">Date Joined From</label>
                  <input type='date' className="form-control" onChange={(e) => setDateJoinedFrom(e.target.value)} />
                </div>
                <div className="form-inline flex-fill">
                  <label className="form-label mb-1 small">To</label>
                  <input type='date' className="form-control" onChange={(e) => setDateJoinedTo(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="d-flex align-items-end gap-2">
                <div className="form-inline flex-fill">
                  <label className="form-label mb-1 small">Donation Date From</label>
                  <input type='date' className="form-control" onChange={(e) => setDonationDateFrom(e.target.value)} />
                </div>
                <div className="form-inline flex-fill">
                  <label className="form-label mb-1 small">To</label>
                  <input type='date' className="form-control" onChange={(e) => setDonationDateTo(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-2 d-flex align-items-end">
              <button className="btn btn-success w-100" onClick={(e) => { e.preventDefault(); getExcel(); }}>
                <i className="fas fa-file-excel me-1"></i> Download Excel
              </button>
            </div>
          </div>

          <div className="px-3 pb-2">
            <div className="alert alert-info d-inline-block py-2 px-3 mb-0">
              <strong>Total Amount:</strong> {formatMoney(totalAmount)}
            </div>
          </div>

          <div className="card-body">
            <TableTwo
              columns={columns}
              data={rows}
              setData={setData}
              skipPageReset={skipPageReset}
              filterTable={rows?.length}
              fileName='donor-classification-reports'
            />
          </div>
        </div>
      </div>
      <Modals show={open && current === 'view'}
        onHide={() => setOpen(false)} title='View Donation' size='md'>
        <dl className="striped">
          {currentData && Object.entries(currentData)?.map(([key, value]) =>
            typeof value !== 'string' && typeof value !== 'number' ? [] :
              <div key={key} className='row'>
                <dt className='col-4'>{`${startCase(key)} :`}</dt>
                {(!edit || key === 'id') && <dd className='col-8'>{value}</dd>}
                {edit && key !== 'id' && <div className="col-8"><input className="form-control" type="text" defaultValue={value} onChange={(e) => setCurrentData({ ...currentData, [key]: e.target.value })} /></div>}
              </div>
          )}
        </dl>
      </Modals>
    </>
  )
}

export default DonorClassificationReport
